import { getMobilityLinePricingErrors } from '../fields/mobilityLinePricing';
import { serializeCatalogEditor, validateCatalogEditor } from './catalogEditorModel';

export const validateMobilityEditor = (values) => validateCatalogEditor('mobility', values, getMobilityLinePricingErrors);
export const serializeMobilityEditor = (sourceConfig, editor, archivedAt) => (
    serializeCatalogEditor(sourceConfig, { ...editor, scope: 'mobility' }, archivedAt)
);
